<template>
  <div class="user">
    <div class="common-form">考试设置</div>
    <div class="product-content">
      <el-form ref="form" :model="form" :rules="formRules" label-width="150px">
        <el-form-item label="是否开启考试" prop="status" :rules="[{required: true,message: ' '}]">
          <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#999999" :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>


        <el-form-item label="是否开启自动跳转" prop="status" :rules="[{required: true,message: ' '}]">
          <el-switch v-model="form.auto_status" active-color="#13ce66" inactive-color="#999999" :active-value="1"
            :inactive-value="0">
          </el-switch>
          <div style="font-size: 10px;color: #999999;">开启后，提交答案会自动跳转</div>
        </el-form-item>

        <el-form-item label="每次做题时间" prop="every_time" >
          <el-input v-model="form.every_time" placeholder="请输入每次做题时间"></el-input>
          <div style="font-size: 10px;color: #999999;">填0不限制时间</div>
        </el-form-item>
 

      </el-form>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </div>
    <el-dialog title="添加积分" :visible.sync="isPoint">
      <el-input v-model="point" autocomplete="off"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePointFunc(false)">取 消</el-button>
        <el-button type="primary" @click="closePointFunc(true)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import ExamApi from '@/api/exam.js';

  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    data() {
      return {
        form: {
          status:"0",//
          every_time:0,//每次做题时间 0不限制做题时间
          auto_status:"0"

        },
        file_path: '',
        Grade: {},
        tableData: [],
        loading: false,
        open_add: false,
        /*是否打开选择商品*/
        isproduct: false,
        exclude_ids: [],
        spec_type: 10,
        /*是否打开图片选择*/
        isupload: false,
        formRules: {
          image_id: [{
            required: true,
            message: '请上传背景图',
            trigger: 'blur'
          }],
        },
        /*左边长度*/
        formLabelWidth: '120px',
        isPoint: false,
        point: '',
        isNothing: false,
        isLottery: -1,
        prize_ids: []
      };
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {

      /*获取数据*/
      getData() {
        let self = this;
        ExamApi.getSetting(true).then(data => {
          self.form = data.data.values;
        }).catch(error => {});
      },
      /*提交表单*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            ExamApi.setting(form, true).then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.tableData = [];
                  self.getData();
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      changeImg(e) {
        this.isLottery = this.tableData.indexOf(e);
        this.isupload = true;
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/plus/exam/setting.vue